<template>
  <div class="newGroup">
    <MapModal
      :modalNode="modalNode"
      :title="newGroupingCategory.title"
      :id="newGroupingCategory.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="75px"
        >
          <el-form-item label="分组名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>

          <el-form-item class="submitBtn btns">
            <el-button @click="closeOneSelf">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
export default {
  components: {
    MapModal,
  },
  data() {
    return {
      newGroupingCategory: {
        title: "新建分组",
        id: "newGroupingPage",
      },
      modalNode: {
        newGroupingCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -650,
          },
          // width: "450px", // 宽度配置 默认450px
          height: "210px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        modelName: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
      form: {
        name: "",
      },
    };
  },
  methods: {
    onSubmit() {
      this.$emit("onSubmitGroupName", this.form);
    },
    closeOneSelf() {
      this.$emit("closeNewGrouping");
    },
  },
};
</script>

<style lang="scss" scoped>
.newGroup {
  .el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding: 8px 0 14px 0;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 166px;
          @include button_primary();
          @include button_default();
        }
      }
    }
  }
}

.el-radio {
  white-space: break-spaces;
  word-break: break-all;
  .el-radio__input {
    line-height: 18px;
    .el-radio__inner {
      margin: 0 3px 0 0;
      @include background_color("t_color3_op2");
      &::after {
        /* 取消选中状态单选框中间的小圆点显示 */
        display: none;
      }
      &:hover {
        @include border_color("t_color1_op1");
      }
    }
    &.is-checked {
      .el-radio__inner {
        // @include border_color('t_color1_op1');
        // @include background_color('t_color1_op1');
        @include border_color("th_color_op1");
        @include background_color("t_color1_op2");
      }
    }
  }
  .el-radio__label {
    padding-left: 2px;
    color: white;
  }
  &.is-checked {
    .el-radio__label {
      @include font_color("t_color_op1");
    }
    .el-radio__inner {
      background-color: #2281b2 !important;
      // @include background_color("t_color1_op1");
    }
  }
}

/deep/.el-button--default {
  border-color: rgba(255, 255, 255, 0.9) !important;
  background-color: rgba(234, 242, 248, 0.3) !important;
  color: rgba(245, 245, 245, 0.6) !important;
}
.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
</style>
